module.exports = __webpack_public_path__ + "img/Mode_Selector_Royal.0c53549c.png";